import { FormattedMessage } from 'react-intl';

import './CareersSelector.css';

interface CareersSelectorProps {
	section: 'contact' | 'open';
	handleSection: (s: 'contact' | 'open') => void;
}

const CareersSelector = ({ section, handleSection }: CareersSelectorProps) => {
	return (
		<section id="careers-selector">
			<button className={`${section === 'open' ? 'active' : ''}`} onClick={() => handleSection('open')}>
				<FormattedMessage id="careers-selector.open" />
			</button>
			<button className={`${section === 'contact' ? 'active' : ''}`} onClick={() => handleSection('contact')}>
				<FormattedMessage id="careers-selector.contact" />
			</button>
		</section>
	);
};

export default CareersSelector;
